import { render } from "./SnehaSparshamApplicationDetails.vue?vue&type=template&id=5e640f60&scoped=true"
import script from "./SnehaSparshamApplicationDetails.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamApplicationDetails.vue?vue&type=script&lang=js"

import "./SnehaSparshamApplicationDetails.vue?vue&type=style&index=0&id=5e640f60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e640f60"]])

export default __exports__